export function formatRecipients(value: string | null | undefined): string {
  if (!value) return '-';
  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) return parsed.join(', ');
  } catch {
    // not JSON — fall through
  }
  return value;
}

export const TEMPLATE_TYPE_LABELS: Record<number, string> = {
  1: 'Email',
  2: 'Statement',
};

export function getStatusBadgeVariant(status: string): 'default' | 'secondary' | 'destructive' | 'outline' {
  switch (status.toLowerCase()) {
    case 'accepted':
    case 'delivered':
      return 'default';
    case 'pending':
      return 'secondary';
    case 'failed':
      return 'destructive';
    default:
      return 'outline';
  }
}
